// Root301 console V1.0 / v0.1.106; 2026-09-15 22:13:20 CST; parents 2babea5a62fff79dcdcc107cd525702ace774b11 / 46bed30ba11c7aa4c37387ae28f698f8a4031b9a.
import type { RedirectTargetProbe, RootRedirectCertificateState, RootRedirectFields, RootRedirectPublicationState } from '../../api/types';

type Tone = 'ok' | 'waiting' | 'bad' | 'muted';
export interface RootStatusView { label: string; tone: Tone; reason: string }
const view = (label: string, tone: Tone, reason?: string | null): RootStatusView => ({ label, tone, reason: reason || '' });

export function rootCertificateView(state?: RootRedirectCertificateState | null): RootStatusView {
  switch (state?.status) {
    case 'BOUND': return view('有效证书已绑定', 'ok', state.reason);
    case 'WAITING_DNS': return view('证书待 DNS 验证', 'waiting', state.reason);
    case 'ISSUING': return view('免费证书申请中', 'waiting', state.reason);
    case 'FAILED': return view('证书处理失败', 'bad', state.reason);
    case 'NOT_CONFIGURED': return view('证书尚未配置', 'waiting', state.reason);
    default: return view('证书状态待确认', 'muted', state?.reason);
  }
}

export function rootProbeView(state?: RedirectTargetProbe | null): RootStatusView {
  if (!state) return view('跳转目标尚未检测', 'muted', '点击“重新检测”获取目标访问结果');
  if (state.status === 'REACHABLE' && state.reachable === true) return view('跳转目标可访问', 'ok', state.reason);
  if (['BUSY', 'INTERRUPTED'].includes(state.status)) return view('跳转目标检测未完成', 'waiting', state.reason);
  if (['INVALID_TARGET', 'BLOCKED_ADDRESS', 'DNS_FAILED', 'TLS_FAILED', 'TIMEOUT', 'HTTP_ERROR', 'REDIRECT_LOOP', 'TOO_MANY_REDIRECTS', 'INVALID_REDIRECT', 'CONNECTION_FAILED'].includes(state.status)) {
    return view('跳转目标无法访问', 'bad', state.reason);
  }
  return view('跳转目标状态待确认', 'muted', state.reason);
}

export function rootPublicationView(state?: RootRedirectPublicationState | null): RootStatusView {
  switch (state?.status) {
    case 'APPLIED': return view(state.https === true ? 'HTTPS 301 已生效' : state.https === false ? 'HTTP 301 已生效' : '301 发布已确认', 'ok', state.reason);
    case 'PENDING': return view('301 配置等待发布', 'waiting', state.reason);
    case 'WAITING_NODES': return view('等待接入节点', 'waiting', state.reason);
    case 'AWAITING_ACK': return view('等待节点确认', 'waiting', state.reason);
    case 'CERTIFICATE_PENDING': return view('等待证书安装', 'waiting', state.reason);
    case 'CERTIFICATE_FAILED': return view('节点证书安装失败', 'bad', state.reason);
    case 'FAILED': return view('301 发布未完成', 'bad', state.reason);
    default: return view('发布状态待确认', 'muted', state?.reason);
  }
}

/** Missing properties do not erase an earlier response; explicit null means the server has no fact. */
export function mergeRootRedirectFields<T extends RootRedirectFields>(value: T, incoming: RootRedirectFields): T {
  return { ...value,
    ...(incoming.certificateState !== undefined ? { certificateState: incoming.certificateState } : {}),
    ...(incoming.redirectTargetProbe !== undefined ? { redirectTargetProbe: incoming.redirectTargetProbe } : {}),
    ...(incoming.publicationState !== undefined ? { publicationState: incoming.publicationState } : {})
  };
}

export function returnedIpv4Values(values: string[]): string[] {
  return [...new Set(values.filter(value => /^(?:0|[1-9]\d{0,2})(?:\.(?:0|[1-9]\d{0,2})){3}$/.test(value)
    && value.split('.').every(octet => Number(octet) <= 255)))];
}
